/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDashboard20 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M17 22H7v-2h4v-3H2V2h20v15h-9v3h4zM4 15h16V4H4zm15-1H5V5h2v7h12zm-5-3-2.5-2.8-.8 1.1H8v-2h1.7l1.7-2.2 2.8 3.2 1.2-.9H18v2h-1.9z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgDashboard20 as Dashboard20 };
